import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SubSubGroupTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-subsubgrouptype-container',
  templateUrl: './subsubgrouptype-container.component.html',
  styleUrls: ['./subsubgrouptype-container.component.scss'],
})
export class SubsubgrouptypeContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  subsubgrouptypes$: Observable<SubSubGroupTypeDto[]>;
  loading: boolean;
  isLoadingSubSubGroupType$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingSubSubGroupType$ = this.gatwayFacade.isLoadingGateway(
      'SubSubGroupType'
    );
    this.subsubgrouptypes$ = this.gatwayFacade.loadGateway('SubSubGroupType');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSubSubGroupType(deletedValue: any) {
    this.gatwayFacade.remove('SubSubGroupType', deletedValue);
  }

  // this method control both the create and update

  onSubmitSubSubGroupType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.SubSubGroupTypes;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllSubSubGroupType = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllSubSubGroupType.push(pullData[i]);
      }
    }

    // check if the addAllSubSubGroupType array is not empty, then dispatch the data to the store
    if (addAllSubSubGroupType.length > 0) {
      this.gatwayFacade.add('SubSubGroupType', addAllSubSubGroupType);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('SubSubGroupType', allUpdates, ['id']);
    }
  }
}
